<div class="panel rs-bg-grey1 clearfix">
  <h3 class="rs-tit6">{{ 'digitalis.manageYourAccount.title' | translate }}</h3>
  <p>
    {{ 'digitalis.manageYourAccount.description' | translate }}
  </p>
  <p>
    <a href="{{ 'digitalis.manageYourAccount.link.url' | translate }}" target="_blank"
      >{{ 'digitalis.manageYourAccount.link.label' | translate
      }}<span class="rs-icon-link-tb"></span
    ></a>
  </p>
</div>
